import * as React from 'react';
import { styled } from '@linaria/react';

import useTickSfx from '@/hooks/use-tick-sfx';

import Demo, { DemoSliderControl } from '@/components/Demo';
import Space from '@/components/Space';

import { Svg, CodeSnippet } from './BasicShapes.shared';

const SIZE = 320;

function RoundedRectangleDemo() {
  const playTick = useTickSfx();

  return (
    <Demo
      id="centered-stroke-demo"
      outputWrapper={OutputWrapper}
      initialValues={{
        rx: 5,
      }}
      CustomGridComponent={ControlsGrid}
      controls={[
        <DemoSliderControl
          key="rx"
          id="rx"
          label="rx"
          min={0}
          max={90}
          step={1}
          onChange={() => {
            playTick();
          }}
        />,
      ]}
    >
      {({ rx }) => {
        const code = `\
<svg width="${SIZE}" height="${SIZE}">
  <rect
    x="80"
    y="100"
    width="140"
    height="100"
    rx="${rx}"
    stroke="green"
    stroke-width="5"
    fill="none"
  />
</svg>\
`;
        return (
          <Wrapper>
            <StyledCodeSnippet code={code} />

            <SvgWrapper>
              <Svg size={SIZE} fill="none">
                <rect
                  x={80}
                  y={100}
                  width={140}
                  height={100}
                  strokeWidth={5}
                  rx={rx}
                  stroke="var(--wham-complementary-500)"
                />
              </Svg>
            </SvgWrapper>
          </Wrapper>
        );
      }}
    </Demo>
  );
}

const HIDE_SNIPPET_AT = '35rem';

const OutputWrapper = styled(Space)`
  container-type: inline-size;
`;

const ControlsGrid = styled.div`
  display: grid;
  gap: 32px;
  grid-template-columns: min(400px, 100%);
  justify-content: center;
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  gap: 16px;
`;

const StyledCodeSnippet = styled(CodeSnippet)`
  max-height: ${SIZE}px;
  overflow-x: auto;
  overflow-y: hidden;

  @container (max-width: ${HIDE_SNIPPET_AT}) {
    display: none;
  }
`;

const SvgWrapper = styled.div`
  display: flex;

  @container (max-width: ${HIDE_SNIPPET_AT}) {
    position: relative;
  }
`;

export default RoundedRectangleDemo;
